// @flow

import languages from './languages'
import projects from './projects'
import status from './status'
import ui from './ui'
import user from './user'

export default {
  languages,
  projects,
  status,
  ui,
  user
}
